import {PageEnums} from "components/nav/PageEnums";

declare var document:any;

import * as React from 'react';
// import {useCallback} from "react";
import * as ReactDOM from 'react-dom';

import {action, observable} from 'mobx';
import { UIState } from 'data/UIState';
import { observer } from 'mobx-react';
import { VoidFunc } from 'types/types';

import './AccountProfile.pcss';
import UserDataSource from "data/UserDataSource";
import {UserAvatarEditor} from "components/account/widgets/UserAvatarEditor";
import {stringOrEmptyString} from "utils";
import {Alert} from "data/Alert";
import {AccountPageWrapper} from "components/account/widgets/AccountPageWrapper";
import {AccountContentContainer} from "components/account/widgets/AccountContentContainer";
import {AccountPages, IAccountPage} from "components/account/Account";
import {useState, useRef} from "react";

interface Props {
  onChangeAccountPage:(page:IAccountPage) => void;
}

export function AccountProfile(props: Props) {

  // use useRef so that the component does not re-render when the value is updated.
  const hasChanges = useRef(false);

  function handleBack() {
    if(hasChanges.current) {
      if(confirm("You have unsaved changes, are you sure you want to leave the profile page without saving?")){
        props.onChangeAccountPage(AccountPages.Overview);
      }
    } else {
      props.onChangeAccountPage(AccountPages.Overview);
    }
  }

  function setHasChanges(_hasChanges:boolean) {
    hasChanges.current = _hasChanges;
  }

  return (
    <AccountPageWrapper
      title={"Profile"}
      subTitle={""}
      backOrCloseAction={handleBack}
      backOrCloseLabel={"Back to Account Overview"}
    >
      <AccountContentContainer>
         <AccountProfileForm
           onBack={handleBack}
           onSetHasChanges={setHasChanges}
         />
        </AccountContentContainer>
      </AccountPageWrapper>
  )

}



interface PropsForm {
  onBack:() => void;
  onSetHasChanges:(hasChanges:boolean) => void;
}


@observer
class AccountProfileForm extends React.Component<PropsForm> {


  @observable firstName:string;
  @observable lastName:string;
  @observable nickname:string;
  @observable hasChanges:boolean = false;
  @observable saving:boolean = false;

  @observable existingAvatarURL:string|null;
  @observable avatarHasChanges:boolean = false;
  avatarBlobData:any;

  constructor(props:PropsForm) {
    super(props);
    this.existingAvatarURL = UIState.user.avatarURL;
    this.firstName = UIState.user.firstName||"";
    this.lastName = UIState.user.lastName||"";
    this.nickname = UIState.user.nickname||"";
  }

  /**
   * Called by the avatar editor when an avatar is added or removed
   * @param data
   */
  @action setAvatarBlobData = (data) => {
    this.avatarBlobData = data;
    this.avatarHasChanges = true;
    if(null===data) {
      this.existingAvatarURL = null;
    }
    this.updateHasChanges();
  }

  /**
   * Called by the avatar editor when an updated avatar is cleared
   */
  @action handleAvatarClear = () => {
    if(!UIState.user.avatarURL) {
      this.avatarHasChanges = false;
      this.updateHasChanges();
    }
  }

  /**
   * Communicate whether there are changes so that a back, X, or cancel
   * will lead with a confirmation before the changes are lost.
   */
  @action updateHasChanges = () => {
    this.hasChanges = this.firstName!==UIState.user.firstName
      || this.lastName!==UIState.user.lastName
      || this.nickname!==UIState.user.nickname
      || this.avatarHasChanges; //this.existingAvatarURL!==UIState.user.avatarURL;
    this.props.onSetHasChanges(this.hasChanges);
  }

  @action save = () => {
    if(!this.saving) {
      this.saving = true;
      let nickname = this.nickname;
      if (nickname) {
        nickname = nickname.trim();
        if (nickname.length < 3) {
          Alert.alert(UserDataSource.constants.NICKNAME_LENGTH_REQUIREMENTS)
          this.saving = false;
          return;
        }
        if (!UserDataSource.utils.isNicknameValid(nickname)) {
          Alert.alert(UserDataSource.constants.NICKNAME_CHAR_REQUIREMENTS)
          this.saving = false;
          return;
        }
      } else {
        nickname = '';
      }

      let firstName = stringOrEmptyString(this.firstName).trim();
      if (0 === firstName.length) {
        Alert.alert("First name is required.");
        this.saving = false;
        return;
      }

      let lastName = stringOrEmptyString(this.lastName).trim();
      if (0 === lastName.length) {
        Alert.alert("Last name is required.");
        this.saving = false;
        return;
      }

      let profileData = {
        firstName: firstName,
        lastName: lastName,
        nickname: nickname,
        avatarBlobData: this.avatarBlobData,
        avatarURL: this.existingAvatarURL,
      };

      UserDataSource.saveUserProfile(UIState.user, profileData)
        .then(action((result: any) => {
          if (undefined == result.nickname && nickname.length > 0) {
            Alert.alert('The nickname \"' + nickname + '\" is already taken by another user. Please enter a different nickname.');
            this.saving = false;
          } else {
            // this.props.onCloseFullBrowserModal();
            UIState.user.firstName = this.firstName
            UIState.user.lastName = this.lastName;
            UIState.user.nickname = this.nickname;
            UIState.user.avatar = result.avatar;
            this.avatarHasChanges = false;

            this.updateHasChanges();
            Alert.alert("Save Complete!");
            this.saving = false;
            this.props.onBack();
          }
        }))
        .catch(() => {
          Alert.alert('Failed to save account. Please make sure that your Internet connection is stable and try again.');
          this.saving = false;
        });
    }
  }

  @action handleNickNameChange = (e)=>{
    const nickname = e.target.value;
    if(!UserDataSource.utils.doesNicknameHaveIllegalCharSequence(nickname)) {
      this.nickname = nickname;
      this.updateHasChanges();
    }
  }

  render() {

    return (

<>
            <fieldset >
            <label htmlFor={"FirstNameAP"}>First Name</label>
            <input type="text" aria-required={true} id="FirstNameAP" name="firstName" value={this.firstName}
                   onChange={action((e)=>{
                     this.firstName = e.target.value;
                     this.updateHasChanges();
                   })} />
            </fieldset>

            <fieldset >
            <label htmlFor={"LastNameAP"}>Last Name</label>
            <input type="text"  aria-required={true} id="LastNameAP" name="lastName" value={this.lastName} onChange={action((e)=>{ this.lastName = e.target.value; this.updateHasChanges(); })}/>
            </fieldset>

            <fieldset className={"account-profile-nickname"}>
              <label htmlFor={"NicknameIP"}>Nickname</label>
              <div><div>@</div><input type="text"  name={"nickname"} id={"NicknameIP"} value={this.nickname} onChange={this.handleNickNameChange}/></div>
            </fieldset>

            <fieldset className={"account-profile-email"}>
              <label>Email</label>
              <div>{UIState.user.email}</div>
              <p>If you need to change the email associated with your account, send a request to strive@well-concepts.com</p>
            </fieldset>

            <fieldset>
              <label>Photo/Avatar</label>
              <UserAvatarEditor hideTitleAndDescription onClear={this.handleAvatarClear} setData={this.setAvatarBlobData} existingAvatarURL={this.existingAvatarURL} />
            </fieldset>

            <div className="action-buttons">
              <div className={"spacer"}></div>
              <button disabled={this.saving} className={"secondary"} onClick={this.props.onBack}>Cancel</button>
              <button  disabled={!this.hasChanges || this.saving} className={"primary"} onClick={this.save}>Save</button>
            </div>

</>

    );
  }
}
